import { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { LogoLockup } from './Logo';

const LINKS = [
  { id: 'about', label: 'About', testid: 'nav-link-about' },
  { id: 'what-we-do', label: 'What We Do', testid: 'nav-link-what-we-do' },
  { id: 'why-us', label: 'Why Us', testid: 'nav-link-why-us' },
  { id: 'how-it-works', label: 'How It Works', testid: 'nav-link-how-it-works' },
  { id: 'maintenance', label: 'Maintenance', testid: 'nav-link-maintenance' },
  { id: 'faq', label: 'FAQ', testid: 'nav-link-faq' },
];

export default function Nav({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    onNavigate(`#${id}`);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-50 border-b border-[#DCBC7F]/15 bg-[#155533]/80 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <button onClick={() => go('top')} className="transition-opacity duration-300 hover:opacity-80" aria-label="The Gate Stays home">
          <LogoLockup />
        </button>
        <nav className="hidden items-center gap-8 lg:flex" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="group relative text-sm font-light text-[#C4D4C9] transition-colors duration-300 hover:text-[#F3E9D7]"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#DCBC7F] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta"
            onClick={() => go('enquiry')}
            className="group hidden items-center gap-2 rounded-full border border-[#DCBC7F]/40 px-5 py-2.5 text-xs font-medium tracking-wide text-[#F3E9D7] transition-colors duration-300 hover:bg-[#DCBC7F] hover:text-[#155533] sm:flex"
          >
            Free Rent Assessment
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="text-[#F3E9D7] lg:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <motion.nav
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="border-t border-[#DCBC7F]/10 bg-[#155533]/95 px-6 pb-6 pt-4 backdrop-blur-xl lg:hidden"
          data-testid="mobile-nav"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-${l.testid}`}
              onClick={() => go(l.id)}
              className="block w-full py-3 text-left font-display text-xl text-[#FCFBFA] transition-colors duration-300 hover:text-[#DCBC7F]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-cta"
            onClick={() => go('enquiry')}
            className="mt-3 w-full rounded-full bg-[#DCBC7F] px-5 py-3 text-sm font-semibold text-[#155533]"
          >
            Free Rent Assessment
          </button>
        </motion.nav>
      )}
    </motion.header>
  );
}
